module.exports = __webpack_public_path__ + "static/media/icon-weibo-trans-selected.7f339921.svg";